import dayjs from 'dayjs';
import isEmpty from 'lodash/isEmpty';
import React, { useContext, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { FormBlock, StepProps } from '@/widgets/ServiceFormTemplate';

import { FormDatePicker, FormInputPhone, FormTextInput, Grid, Informer, StepControlPanel } from '@/shared/ui';

import { formatDate } from '@/helpers/dates';

import AuthContext from '@/contexts/Auth/AuthContext';

import { LEGAL_AGE } from '@/lib/consts';

import { InsuredDataSchema } from '../../model/types';

export const InsuredData: React.FC<StepProps> = ({ next, prev }) => {
  const { userData } = useContext(AuthContext);
  const { control, getValues, setValue } = useFormContext<InsuredDataSchema>();

  useEffect(() => {
    if (isEmpty(userData)) return;

    const formData = getValues();

    isEmpty(formData.lastName) && setValue('lastName', userData.name_last);
    isEmpty(formData.firstName) && setValue('firstName', userData.name_first);
    isEmpty(formData.middleName) && userData.name_middle && setValue('middleName', userData.name_middle);
    isEmpty(formData.birthday) && setValue('birthday', userData.date_of_birth);
    isEmpty(formData.rnokpp) && setValue('rnokpp', userData.drfo_code);
    isEmpty(formData.email) && userData.contact_email && setValue('email', userData.contact_email);
    isEmpty(formData.phone) && userData.contact_phone && setValue('phone', userData.contact_phone);
  }, [getValues, setValue, userData]);

  return (
    <>
      <FormBlock title="Особисті дані страхувальника">
        <FormTextInput name="lastName" control={control} label="Прізвище" required disabled readOnly />
        <FormTextInput name="firstName" control={control} label="Ім'я" required disabled readOnly />
        <FormTextInput name="middleName" control={control} label="По батькові" disabled readOnly />
        <FormDatePicker
          name="birthday"
          control={control}
          label="Дата народження"
          required
          maxDate={dayjs().subtract(LEGAL_AGE, 'years')}
        />
        <FormTextInput
          name="rnokpp"
          control={control}
          label="Ідентифікаційний код (РНОКПП)"
          required
          disabled
          readOnly
        />
        <FormTextInput name="email" control={control} label="Email" required placeholder="example@example.com" />
        <FormInputPhone name="phone" control={control} label="Номер телефону" required />

        <Informer
          icon={{
            name: 'attention',
            color: 'blue',
          }}
          header={{
            color: 'blue',
            text: 'Будьте уважні!',
          }}
          text={{
            color: 'black',
            text: 'Будь ласка, введіть актуальний номер телефону на який ми надішлемо СМС-код для підтвердження укладення електронного договору страхування.',
          }}
          borderColor="blue"
        />
      </FormBlock>

      <StepControlPanel prev={prev} next={next} />
    </>
  );
};

export const InsuredDataPreview: React.FC = () => {
  const { getValues } = useFormContext<InsuredDataSchema>();
  const { lastName, firstName, middleName, birthday, rnokpp, email, phone } = getValues();

  return (
    <Grid
      title="Особисті дані страхувальника"
      data={[
        ['Прізвище', lastName],
        ['Імʼя', firstName],
        ['По батькові', middleName],
        ['Дата народження', formatDate(birthday)],
        ['Ідентифікаційний код (РНОКПП)', rnokpp],
        ['Email', email],
        ['Номер телефона', phone],
      ]}
    />
  );
};
